<template>
  <div class="speed">
    <BModal :active="isModalOpen" width="31.25em" :can-cancel="false">
      <div class="speed__container">
        <div class="speed__container__close" @click="onClickClose">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_close.png" alt="close" />
        </div>
        <div class="speed__container__title">
          Velocidad de reproducción:
        </div>
        <div class="speed__container__options">
          <div
            role="button"
            v-for="(numberValue, index) of arraySpeedOptions"
            :key="index"
            @click="onClickSpeed(numberValue)"
          >
            <div class="img"></div>
            <div>
              <span :class="{ active: numberValue === currentSpeed }">{{ numberValue }}x</span>
              <span v-if="numberValue === 1">- normal</span>
            </div>
          </div>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerSpeedModal',
  components: {
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: true,
    },
    currentSpeed: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      arraySpeedOptions: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
    };
  },
  methods: {
    onClickSpeed(numberValue) {
      this.$emit('click-speed', numberValue);
    },
    onClickClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.speed {
  font-size: 1rem;
  &__container {
    width: 100%;
    padding: 1.5em 1.25em 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background-color: white;
    border-radius: 1em;

    &__close {
      position: absolute;
      right: 0.25em;
      top: 0.25em;
      cursor: pointer;
    }

    &__title {
      font-family: Roboto-Bold, sans-serif;
      font-size: 1.0625em;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.68;
      letter-spacing: -0.17px;
      text-align: center;
      color: #132839;
    }

    &__options {
      width: 100%;
      margin-top: 1.25em;

      & > div {
        padding: 9px 14px;
        border-radius: 6px;
        background-color: #132839;
        font-family: Roboto-Regular, sans-serif;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.97;
        letter-spacing: -0.12px;
        text-align: center;
        color: #fff;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;

        & span.active {
          font-family: Roboto-Bold, sans-serif;
          font-weight: bold;
        }

        & > div.img {
          height: 16px;
          width: 16px;
          margin-right: 16px;
        }
      }
    }
  }
}
</style>
